'use client';

import { Button } from '@mui/material';
import { usePageAction } from '@repo/hooks/usePageAction';

type Props = {
  reviewLink?: string;
  institution?: {
    id: string;
    name?: string;
  };
};

export const ReviewButton = ({ reviewLink, institution }: Props) => {
  const readReviewButtonClickEvent = usePageAction({
    actionDestinationUrl: reviewLink,
    actionName: 'nw_review_redirected',
    actionSection: 'banking_cd_institution_card',
    actionType: 'select',
    additionalAttributes: {
      institution_id: institution?.id,
      institution_nm: institution?.name,
    },
  });

  if (!reviewLink) return null;

  const handleButtonOnClick = () => {
    readReviewButtonClickEvent();
  };

  return (
    <Button
      fullWidth
      sx={{ textWrap: 'nowrap', minWidth: '130px' }}
      href={reviewLink}
      target="_blank"
      onClick={handleButtonOnClick}
    >
      Read Review
    </Button>
  );
};
